import axios, { AxiosRequestConfig } from 'axios';
import { getAuthBasicHeader } from 'commerce/scayle/auth/backend/getAuthBasicHeader';
import {
  FACT_FINDER_HOST,
  FACT_FINDER_PASSWORD,
  FACT_FINDER_USER,
} from 'src/envVariables';

export const fetchFF = <T>(path: string, config: AxiosRequestConfig) => {
  const isClient = typeof window !== 'undefined';
  let fetcher;

  if (!isClient) {
    fetcher = axios.create({
      baseURL: FACT_FINDER_HOST,
      headers: getAuthBasicHeader(FACT_FINDER_USER, FACT_FINDER_PASSWORD),
    });
  } else {
    fetcher = axios.create({
      baseURL: '/api/factFinder',
    });
  }

  return fetcher.get<T>(path, config);
};
